import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { plans } from "../../store/plans/actions";
export var useGetPlansAll = function (trigger, clientId, projectId, planName, paymentModeId, coverTypeId) {
    var _a = useState(true), enable = _a[0], setEnable = _a[1];
    var _b = useState(1), page = _b[0], setPage = _b[1];
    var _c = useState(100), limit = _c[0], setLimit = _c[1];
    var dispatch = useDispatch();
    var _d = useSelector(function (state) {
        var _a;
        return ({
            responsePlans: (_a = state.Plans.responsePlans) === null || _a === void 0 ? void 0 : _a.data,
            errorPlans: state.Plans.errorPlans,
            loadingPlans: state.Plans.loadingPlans,
        });
    }), responsePlans = _d.responsePlans, errorPlans = _d.errorPlans, loadingPlans = _d.loadingPlans;
    var _e = useSelector(function (state) {
        var _a;
        return ({
            responsePlansN: (_a = state.Plans.responsePlans) === null || _a === void 0 ? void 0 : _a.data,
            errorPlansN: state.Plans.errorPlans,
            loadingPlansN: state.Plans.loadingPlans,
        });
    }), responsePlansN = _e.responsePlansN, errorPlansN = _e.errorPlansN, loadingPlansN = _e.loadingPlansN;
    useEffect(function () {
        if (trigger) {
            dispatch(plans({
                enable: enable,
                page: page,
                limit: limit,
                projectId: projectId,
                //planname: planName,
                //paymentModeId: paymentModeId,
                //coverTypeId: coverTypeId,
                clientId: clientId,
            }));
        }
    }, [
        enable,
        page,
        limit,
        projectId,
        planName,
        paymentModeId,
        coverTypeId,
        clientId,
        trigger,
    ]);
    return {
        responsePlans: responsePlans,
        errorPlans: errorPlans,
        loadingPlans: loadingPlans,
        responsePlansN: responsePlansN,
        errorPlansN: errorPlansN,
        loadingPlansN: loadingPlansN,
        setEnable: setEnable,
        setPage: setPage,
        setLimit: setLimit,
    };
};
